const API_BASE_URL = 'http://localhost:8080/api'
// const API_BASE_URL = 'https://glistening-dedication-production.up.railway.app/api'



export default API_BASE_URL;
